
/**
 * AES 加解密
 * Filename: aes.js
 * Author: GaoYu
 * Time: 2020/6/8 19:04
 */
import CryptoJS from 'crypto-js'

const keyStr = 'sgy459sf03#$5^&b'
const iv = '1234567890123456'

const aesEncrypt = (word) => {
  let key = CryptoJS.enc.Utf8.parse(keyStr) // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(iv)
  })
  return encrypted.toString()
}

const aesDecrypt = (word) => {
  let key = CryptoJS.enc.Utf8.parse(keyStr) // Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  let decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(iv)
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

export default {
  aesEncrypt,
  aesDecrypt
}



// WEBPACK FOOTER //
// ./src/utils/aes.js